import PropTypes from "prop-types";
import Tooltip from "@shared/v2/Tooltip";
import { CircleInfoSolidV6 } from "@shared/v2/Icomoon";
import { TH } from "./BusinessDashboard/Table/Table";

const getSortDir = (sortKey, name, sortDesc) => {
  if (sortKey === name) return sortDesc ? "desc" : "asc";
  return null;
};

const ReportHeader = ({ handleSort, name, styles, label, sortKey, sortDesc, className, tooltipDesc }) => (
  <TH
    style={styles}
    className={className}
    sort={getSortDir(sortKey, name, sortDesc)}
    onSort={() => handleSort(name)}
  >
    {tooltipDesc ? (
      <>
        {label}{" "}
        <Tooltip
          tooltipClassName="tw-max-w-[244px]"
          placement="top"
          trigger={<CircleInfoSolidV6 className="tw-text-theme-primary" />}
          content={tooltipDesc}
        />
      </>
    ) : (
      label
    )}
  </TH>
);

ReportHeader.propTypes = {
  handleSort: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  styles: PropTypes.shape(),
  label: PropTypes.string.isRequired,
  sortKey: PropTypes.string.isRequired,
  sortDesc: PropTypes.bool.isRequired,
  className: PropTypes.string,
  tooltipDesc: PropTypes.string,
};

ReportHeader.defaultProps = {
  styles: undefined,
  className: "",
  tooltipDesc: "",
};

export default ReportHeader;
